module.exports = __webpack_public_path__ + "media/images/logos/linkedin-d4e831ec146df780cd9b4e84346148f3.svg";